import React from "react";

const Laptop = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
              d="M3.455 6.492C3.455 5.667 4.116 5 4.897 5h26.206c.797 0 1.442.667 1.442 1.492V25.74H3.455V6.49ZM2 28.704h32v2.963H2v-2.963Z"
              fill={fill}
        />
    </svg>
);

export default Laptop;